import React from 'react'
import cx from 'classnames'

import s from './Box.scss'


const allowedKeys   = [ 'm', 'mt', 'mr', 'mb', 'ml', 'p', 'pt', 'pr', 'pb', 'pl' ] as const
const allowedSizes  = [ '4', '8', '12', '16', '20', '24', '32', '36', '40', '48', '56', '60', '64', '72', '80', '96' ] as const

type Key = typeof allowedKeys[number]
type Size = '4' | '8' | '12' | '16' | '20' | '24' | '32' | '36' | '40' | '48' | '56' | '60' | '64' | '72' | '80' | '96'
type SizeProps = { [ key in Key ]?: Size }

const getClasses = (keys: SizeProps): string[] => {
  const classes = []

  Object.keys(keys).forEach((key: typeof allowedKeys[number]) => {
    const value = keys[key]

    if (!value) {
      return
    }

    if (!allowedKeys.includes(key)) {
      console.error(`Wrong "key" – ${key} passed to Box component`)
    }

    if (!allowedSizes.includes(value)) {
      console.error(`Wrong "value" – ${value} passed for key "${key}" to Box component`)
    }

    classes.push(s[`${key}_${value}`])
  })

  return classes
}

interface BoxProps {
  children?: React.ReactNode
  id?: string
  className?: string
  alignCenter?: boolean
  alignRight?: boolean
  alignLeft?: boolean
  center?: boolean
  relative?: boolean
  inline?: string
  m?: Size
  mt?: Size
  mr?: Size
  mb?: Size
  ml?: Size
  p?: Size
  pt?: Size
  pr?: Size
  pb?: Size
  pl?: Size
  dataTestId?: string
}

const Box: React.FunctionComponent<BoxProps> = (props) => {
  const {
    children, className, id, alignCenter, alignRight, alignLeft,
    center, inline, relative, dataTestId, ...keys
  } = props

  const rootClassName = cx(className, ...getClasses(keys), {
    [s.center]: center,
    [s.inline]: inline,
    [s.relative]: relative,
    [s.alignCenter]: alignCenter,
    [s.alignRight]: alignRight,
    [s.alignLeft]: alignLeft,
  })

  return (
    <div className={rootClassName} id={id} data-testid={dataTestId}>
      {children}
    </div>
  )
}


export default Box
